var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIconInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45591 18.3643C9.12007 18.1008 8.77579 17.8367 8.42758 17.5696C6.95126 16.4373 5.40418 15.2507 4.1292 13.8225C2.57067 12.0766 1.45996 10.0097 1.45996 7.32168C1.45996 4.66519 2.9692 2.4163 5.06243 1.46448C7.12479 0.526693 9.84271 0.81258 12.3605 3.41618L12.7199 3.78781L13.0793 3.41622C15.5971 0.813205 18.3151 0.527555 20.3775 1.46549C22.4707 2.41746 23.98 4.66637 23.98 7.32285C23.98 10.0103 22.8695 12.0772 21.3112 13.8229C20.034 15.2536 18.4836 16.4417 17.0047 17.5751C16.6592 17.8399 16.3176 18.1017 15.9842 18.3629L15.9837 18.3634C15.369 18.8465 14.7967 19.2895 14.2382 19.6142C13.6796 19.939 13.1817 20.1168 12.72 20.1168C12.2583 20.1168 11.7605 19.9388 11.2017 19.6139C10.6431 19.2891 10.0708 18.8464 9.45591 18.3643ZM9.45591 18.3643L9.14763 18.7572L9.45578 18.3642C9.45582 18.3642 9.45586 18.3642 9.45591 18.3643Z",
    fill: "#FFE4E5",
    stroke: "#EC5569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIconInactive);
export default __webpack_public_path__ + "static/media/heartIconInactive.53384201e2052f5a1361a85680cfbcf2.svg";
export { ForwardRef as ReactComponent };